import { ILead } from "./lead"

export enum ETrackingNotificationsStatusCalled {
    NOT_CALLED = 'NOT_CALLED',
    CALLED = 'CALLED',
    CANCEL_CALLED = 'CANCEL_CALLED',
  }
  export enum ETrackingNotificationsStatusFollow {
    WAIT = 'WAIT',
    DONE = 'DONE',
  }

  export enum EExpiredDateStatus {
    EXPIRED = 'EXPIRED',
    NOT_EXPIRED = 'NOT_EXPIRED',
  }

export interface ITrackingNotifications {
    objectId?: string
    lead: ILead
    actor: string
    expiredAt: Date | string
    deletedAt?: Date | string
    merchantPrefix: string
    assignTo: ILeadAssignTo
    statusCalled: ETrackingNotificationsStatusCalled
    statusFollow: ETrackingNotificationsStatusFollow
    note?: string
    _id?: string
    createdAt?: Date | string
    updatedAt?: Date | string
  }
  
  export interface ILeadAssignTo {
    objectId: string
    username: string
    name: string
  }

  export interface ITrackingNotificationsGetCalendar {
    date: Date | string
    count: number
    pending: number
    success: number
  }

  export interface ITrackingNotificationsGetReportAssignTo {
    date: Date | string
    item: number
    success: number
    unSuccess: number
    assignTo: ILeadAssignTo
  }
  